/*
  Routes for whole Admin 
*/

import React from 'react';
import LOCALIZATION from 'services/LocalizationService';

// Application URLs
import URL from "constants/ApplicationUrls";

/* Routes */
const TaskCenter = React.lazy(() => import('components/TaskCenter/Admin'))

const AddProject = React.lazy(() => import('components/Project/Create'))

const NewmanTanks = React.lazy(() => import('components/singleProjectDetail'))

const Personnel = React.lazy(() => import('components/Personnel/List'))
const AddPerson = React.lazy(() => import('components/Personnel/AddPerson'))
const StatusCodesList = React.lazy(() => import('components/StatusCodes/List'))
const AddEditStatusCode = React.lazy(() => import('components/StatusCodes/AddEdit'))
const AccommodationSetupList = React.lazy(() => import('components/AccommodationSetup/List'))
const AddEditAccommodationSetup = React.lazy(() => import('components/AccommodationSetup/AddEdit'))
const AccommodationBookingList = React.lazy(() => import('components/AccommodationBooking/List'))
const AddEditAccommodationBooking = React.lazy(() => import('components/AccommodationBooking/AddEdit'))
const RostersList = React.lazy(() => import('components/Rosters/List'))
const AddEditRoster = React.lazy(() => import('components/Rosters/AddEdit'))

const Flights = React.lazy(() => import('components/Flights/List'))

const Accomodation = React.lazy(() => import('components/Accomodation/List'))
const UserManagement = React.lazy(() => import('components/UserManagement/List'))

// Change Requests
const MyChangeRequests = React.lazy(() => import('components/ChangeRequests/MyRequests'))
const ReviewChangeRequests = React.lazy(() => import('components/ChangeRequests/ReviewRequests'))
const ArchivedProjects = React.lazy(() => import('components/Project/ArchivedProjects'))



const ROUTES = [

  // Personnel - First route for Admin users
  { path: URL.PERSONNEL_LIST, exact: true, component: Personnel, name: LOCALIZATION.PERSONNEL },
  { path: URL.PERSONNEL_ADD, exact: true, component: AddPerson, name: LOCALIZATION.ADD_PERSON },

  // Tash Center
  { path: URL.TASK_CENTER, exact: true, component: TaskCenter, name: LOCALIZATION.TASK_CENTRE },


   // Tash Center Filter
   { path: URL.TASK_CENTER_FILTER, exact: true, component: TaskCenter, name: LOCALIZATION.TASK_CENTRE },

  // Prpjects
  { path: URL.ADD_PROJECTS, exact: true, component: AddProject, name: LOCALIZATION.ADD_PROJECTS },

  // Single Project Detail
  { path: URL.PROJECT_DETAIL, exact: true, component: NewmanTanks},
  
  // Status Codes
  { path: URL.STATUS_CODE_LIST, exact: true, component: StatusCodesList, name: LOCALIZATION.STATUS_CODES },
  { path: URL.STATUS_CODE_ADD, exact: true, component: AddEditStatusCode, name: LOCALIZATION.ADD_STATUS_CODE },
  { path: URL.STATUS_CODE_EDIT, exact: true, component: AddEditStatusCode, name: LOCALIZATION.EDIT_STATUS_CODE },
  
  // Accommodation Setup
  { path: URL.ACCOMMODATION_SETUP_LIST, exact: true, component: AccommodationSetupList, name: LOCALIZATION.ACCOMMODATION_SETUP },
  { path: URL.ACCOMMODATION_SETUP_ADD, exact: true, component: AddEditAccommodationSetup, name: LOCALIZATION.ADD_ACCOMMODATION_LOCATION },
  { path: URL.ACCOMMODATION_SETUP_EDIT, exact: true, component: AddEditAccommodationSetup, name: LOCALIZATION.EDIT_ACCOMMODATION_LOCATION },
  
  // Accommodation Booking
  { path: URL.ACCOMMODATION_BOOKING_LIST, exact: true, component: AccommodationBookingList, name: LOCALIZATION.ACCOMMODATION_BOOKINGS },
  { path: URL.ACCOMMODATION_BOOKING_ADD, exact: true, component: AddEditAccommodationBooking, name: LOCALIZATION.ADD_ACCOMMODATION_BOOKING },
  { path: URL.ACCOMMODATION_BOOKING_EDIT, exact: true, component: AddEditAccommodationBooking, name: LOCALIZATION.EDIT_ACCOMMODATION_BOOKING },
  
  // Rosters
  { path: URL.ROSTER_LIST, exact: true, component: RostersList, name: LOCALIZATION.ROSTERS },
  { path: URL.ROSTER_ADD, exact: true, component: AddEditRoster, name: LOCALIZATION.ADD_ROSTER },
  { path: URL.ROSTER_EDIT, exact: true, component: AddEditRoster, name: LOCALIZATION.EDIT_ROSTER },

  // Flights
  { path: URL.FLIGHTS_LIST, exact: true, component: Flights, name: LOCALIZATION.FLIGHTS },

  // Accomodation
  { path: URL.ACCOMODATION_LIST, exact: true, component: Accomodation, name: LOCALIZATION.ACCOMODATION },
  
  // User Management
  { path: URL.USER_MANAGEMENT, exact: true, component: UserManagement, name: LOCALIZATION.USER_MANAGEMENT },
  
  // Management - External URL handled in menu, no route needed

  // Change Requests
  { path: URL.MY_CHANGE_REQUESTS, exact: true, component: MyChangeRequests, name: 'My Change Requests' },
  { path: URL.REVIEW_CHANGE_REQUESTS, exact: true, component: ReviewChangeRequests, name: 'Review Change Requests' },

  // Archived Projects
  { path: URL.ARCHIVED_PROJECTS, exact: true, component: ArchivedProjects, name: 'Archived Projects' },
];

export default ROUTES;